import { MultiMatchQueryV1, QueryV1 } from '@ttab/elephant-api/index'
import type { SearchFieldConfig } from '../types'
import { buildAdvancedQuery } from './buildQuery'
import { createQuerySyntaxState } from './defaultState'
import { booleanQueryString } from './isValidQuerySyntax'

/**
 * Free text using operators, required or excluded terms, groups or fields reads as
 * advanced search's query syntax. Anything else is a phrase prefix on the view's fields:
 * as a query string, plain words would be OR:ed across all fields, and text the parser
 * rejects gets an error from the index indistinguishable from an outage.
 */
export function buildFreeTextQuery(
  text: string,
  fields: SearchFieldConfig[],
  phraseFields: string[] = fields.filter((f) => f.defaultSelected).map((f) => f.fieldPath)
): QueryV1 | undefined {
  const raw = text.trim()
  if (!raw) {
    return undefined
  }

  const queryString = booleanQueryString(raw, fields)
  if (queryString !== undefined) {
    return buildAdvancedQuery(createQuerySyntaxState(queryString), fields)
  }

  return QueryV1.create({
    conditions: {
      oneofKind: 'multiMatch',
      multiMatch: MultiMatchQueryV1.create({
        fields: phraseFields,
        query: raw,
        type: 'phrase_prefix'
      })
    }
  })
}
